import { assetURL, DefaultTheme } from '../../components/theme';

export const CSS = {
	container: 'c-CapturePreview',
	border: 'c-CapturePreview--border',
	wrapper: 'c-CapturePreviewWrapper',
	image: 'c-CapturePreview__Image',
	overlay: 'c-CapturePreview__Overlay',
	selectable: 'c-CapturePreview__Image--selectable',
	selected: 'c-CapturePreview__Image--selected',
	crosshair: 'c-CapturePreview__Crosshair',
	truesize: 'c-CapturePreview__truesize',
	photomeasure: 'c-CapturePreview__photomeasure',
	date: 'c-CapturePreview__date',
	hiddenCapture: 'c-CapturePreview__hiddenCapture',
};

export const Style = {
	[CSS.container]: {
		position: 'relative',
		width: '100%',
		height: '100%',
	},
	// Not `left: 50%`, which caps shrink-to-fit at half the container — the photo then sized itself from
	// height alone and overflowed into the neighbouring carousel slide (UFO-1310). The width hugs the photo
	// while the height stays definite, so the image below can resolve `max-height` and the annotation
	// overlay, sized to 100% of this box, stays registered with the photo.
	[CSS.wrapper]: {
		position: 'absolute',
		left: 0,
		right: 0,
		margin: '0 auto',
		width: 'fit-content',
		maxWidth: '100%',
		height: `100%`,
		// Scoped so the thumbnail variants keep sizing off height alone; both dimensions auto to keep the ratio.
		[`& .${CSS.image}`]: {
			display: 'block',
			width: 'auto',
			height: 'auto',
			maxWidth: '100%',
			maxHeight: '100%',
		},
	},
	[CSS.border]: {
		border: `${DefaultTheme.space(1)} solid transparent`,
	},
	[CSS.crosshair]: {
		position: 'absolute',
		display: 'block',
		top: 0,
		bottom: 0,
		left: 0,
		right: 0,
		'background-image': assetURL('/images/p2p-dot.png'),
		'background-position': '50%',
		'background-repeat': 'no-repeat',
		'background-size': '40%',
		'pointer-events': 'none',
	},
	[CSS.overlay]: {
		position: 'absolute',
		width: '100%',
		height: '100%',
		top: 0,
		left: 0,
	},
	[CSS.image]: {
		height: '100%',
	},
	[CSS.selectable]: {
		cursor: 'pointer',
	},
	[CSS.selected]: {
		cursor: 'default',
		border: `${DefaultTheme.space(1)} solid ${DefaultTheme.color.accent}`,
	},
	[CSS.truesize]: {
		display: 'flex',
		'justify-content': 'center',
		'align-items': 'center',
		position: 'absolute',
		bottom: 0,
		right: 0,
		width: '24px',
		height: '24px',
		'border-radius': '50%',
		'background-color': DefaultTheme.background.offWhite,
		'box-shadow': DefaultTheme.shadow.box.dp2,
		'background-image': assetURL('/images/ike_logo_no-text.svg'),
		'background-size': '100%',
		'background-repeat': 'no-repeat',
	},
	[CSS.truesize + ' svg']: {
		width: '24px',
		height: '24px',
	},
	[CSS.photomeasure]: {
		position: 'absolute',
		right: `-${DefaultTheme.space(2)}`,
		bottom: `-${DefaultTheme.space(2)}`,
		'background-image': assetURL('/images/ike_logo_no-text.svg'),
		'background-repeat': 'no-repeat',
		'background-position': '50%',
		'background-size': 'cover',
		'border-radius': '50%',
		'background-color': DefaultTheme.background.offWhite,
		border: `1px solid ${DefaultTheme.background.offWhite}`,
		width: DefaultTheme.space(5),
		height: DefaultTheme.space(5),
	},
	[CSS.date]: {
		position: 'absolute',
		left: DefaultTheme.space(0.5),
		bottom: DefaultTheme.space(0.5),
		'background-color': 'rgba(224, 224, 224, 0.75)',
		'font-size': '10px',
		color: DefaultTheme.font.color.primary,
		'line-height': 'normal',
	},
	[CSS.hiddenCapture + '>:not(i)']: {
		filter: 'grayscale(100%) brightness(40%)',
	},
};
